
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ExpireSubscriptionModal = ({ show, handleClose, content, diffDay, setDiffDay, link }) => {
    return (
        <Modal id="ExpireSubscriptionModal" show={show} onHide={handleClose} backdrop="static" centered size="md">
            <Modal.Header closeButton className='border-bottom-0'>
                <Modal.Title className="gth-modal-title"></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="plan_expire_soon text-center mb-5">
                    {/* <h3 className='fw-bold text-danger mb-4'>Your subscription has expired !</h3> */}
                    <img
                        src={`${process.env.PUBLIC_URL}/assets/images/warning.jpg`}
                        alt="Expire"
                        className="img-fluid"
                        width={"110px"}
                        height={"110px"}
                    />
                    {content}
                    {link ?
                        <div className='d-flex justify-content-center mt-3'>
                            <Link to={link} target='_blank' className='btn btn-success'>Renew Now</Link>
                        </div> : ""
                    }
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ExpireSubscriptionModal;
